import { MODIFY_ENROLLMENT } from '../../../../api/endpoints';
import request from '../../../../api/request';
import { ModifyEnrollmentFormDataResponse } from './types';

/**
 * datos para el formulario de modificar cambio de plan de estudio
 */
export function modifyEnrollmentFormData(
  studyPlanEnrollmentId: string | number,
) {
  return request<ModifyEnrollmentFormDataResponse>(
    MODIFY_ENROLLMENT.MODIFY_FORM_DATA_TO_CONTINUITY(studyPlanEnrollmentId),
  );
}

export function modifyEnrollment(
  studyPlanEnrollmentId: string | number,
  data: { studyPlanVersionOfferId: number },
) {
  return request<ModifyEnrollmentFormDataResponse>(
    MODIFY_ENROLLMENT.MODIFY_TO_CONTINUITY(studyPlanEnrollmentId),
    { method: 'POST', data },
  );
}
